<div class="mt-3 sm:mt-0 sm:text-left flex-shrink-0">
  @if (loading) {
  <ngx-skeleton-loader
    [theme]="{ width: '100%', height: '256px', 'border-radius': '8px' }"
  ></ngx-skeleton-loader>
  } @else {
  <img
    [src]="imageUrl"
    [alt]="'Imagen del producto'"
    class="w-full sm:w-64 h-64 object-cover rounded-lg"
    (error)="onImageError($event)"
  />
  }
</div>
